<health-data-page
    [chartLabel]="chartLabel"
    [chartConfiguration]="chartConfiguration"
    [healthDataLabel]="healthDataLabel"
    [healthDataType]="healthDataType"
    [hasTwoDecimals]="hasTwoDecimals"
    [aggregateOperation]="HealthDataAggregateOperation.SUM"
    [payloadTypes]="payloadTypes"
/>
